import { useThemeStore } from './themeStore';

/**
 * Hook personnalisé pour utiliser le thème dans les composants
 */
export function useTheme() {
  const { theme, setTheme, toggleTheme } = useThemeStore();
  
  const isDark = theme === 'dark';
  const isLight = theme === 'light';
  
  return {
    theme,
    isDark,
    isLight,
    setTheme,
    toggleTheme,
    // Classes CSS utiles basées sur le thème
    classes: {
      card: 'card shadow-lg border-0',
      button: {
        primary: 'btn btn-primary',
        secondary: 'btn btn-secondary',
        outline: 'btn btn-outline-primary',
      },
      text: {
        primary: 'text-theme-primary',
        secondary: 'text-theme-secondary',
        muted: 'text-muted',
      },
      background: {
        primary: 'bg-theme-primary',
        secondary: 'bg-theme-secondary',
        tertiary: 'bg-theme-tertiary',
      }
    }
  };
}

/**
 * Composant wrapper pour appliquer le thème automatiquement
 */
export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const { theme } = useThemeStore();
  
  // S'assurer que l'attribut data-theme est défini
  React.useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);
  
  return <>{children}</>;
}

/**
 * Composant bouton de basculement de thème réutilisable
 */
export function ThemeToggleButton({ 
  className = "btn btn-link nav-link d-flex align-items-center",
  showText = true 
}: { 
  className?: string;
  showText?: boolean;
}) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';
  
  return (
    <button
      className={className}
      onClick={toggleTheme}
      title={isDark ? 'Passer au mode clair' : 'Passer au mode sombre'}
    >
      {isDark ? (
        <Sun size={18} className={showText ? "me-2" : ""} />
      ) : (
        <Moon size={18} className={showText ? "me-2" : ""} />
      )}
      {showText && (isDark ? 'Clair' : 'Sombre')}
    </button>
  );
}

// Import des icônes nécessaires
import { Moon, Sun } from 'lucide-react';
import React from 'react';
